export const MISSION_NEW_REQUEST = 'MISSION_NEW_REQUEST';
export const MISSION_NEW_SUCCESS = 'MISSION_NEW_SUCCESS';
export const MISSION_NEW_FAIL = 'MISSION_NEW_FAIL';
export const MISSION_NEW_RESET = 'MISSION_NEW_RESET';

export const MISSION_ALL_REQUEST = 'MISSION_ALL_REQUEST';
export const MISSION_ALL_SUCCESS = 'MISSION_ALL_SUCCESS';
export const MISSION_ALL_FAIL = 'MISSION_ALL_FAIL';

export const MISSION_BY_ID_REQUEST = 'MISSION_BY_ID_REQUEST';
export const MISSION_BY_ID_SUCCESS = 'MISSION_BY_ID_SUCCESS';
export const MISSION_BY_ID_FAIL = 'MISSION_BY_ID_FAIL';
export const MISSION_BY_ID_RESET = 'MISSION_BY_ID_RESET';

export const MISSION_UPDATE_BY_ID_REQUEST = 'MISSION_UPDATE_BY_ID_REQUEST';
export const MISSION_UPDATE_BY_ID_SUCCESS = 'MISSION_UPDATE_BY_ID_SUCCESS';
export const MISSION_UPDATE_BY_ID_FAIL = 'MISSION_UPDATE_BY_ID_FAIL';
export const MISSION_UPDATE_BY_ID_RESET = 'MISSION_UPDATE_BY_ID_RESET';

export const MISSION_DELETE_REQUEST = 'MISSION_DELETE_REQUEST';
export const MISSION_DELETE_SUCCESS = 'MISSION_DELETE_SUCCESS';
export const MISSION_DELETE_FAIL = 'MISSION_DELETE_FAIL';
